import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { SkipOrLaunchBaComponent } from './skip-or-launch-ba.component';

@NgModule({
    imports: [CommonModule, CoreUiModule],
    declarations: [SkipOrLaunchBaComponent],
    exports: [SkipOrLaunchBaComponent]
})
export class SkipOrLaunchBaModule {}
